import { render } from "./RDSPLayer.vue?vue&type=template&id=50d8e10d"
import script from "./RDSPLayer.vue?vue&type=script&lang=js"
export * from "./RDSPLayer.vue?vue&type=script&lang=js"

import exportComponent from "/home/drusso/rds-workspace/it-rds-active/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__